import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/acl/roles', {params});
  },
  detail(id: string | number, params = {}) {
    return axios.get(`/acl/roles/${id}`, {params});
  },
  create(payload = {}) {
    return axios.post('/acl/roles', payload);
  },
  update(id: string | number, payload = {}) {
    return axios.patch(`/acl/roles/${id}`, payload);
  },
  delete(id: string | number) {
    return axios.delete(`/acl/roles/${id}`);
  },
};
